import {
  ILSHeaderPlaceholder,
  ILSParagraphPlaceholder,
} from "@components/ILSPlaceholder";
import { ShowMoreContent } from "@components/ShowMoreContent";
import LiteratureCover from "@modules/Literature/LiteratureCover";
import SpecialCollectionAuthors from "@modules/SpecialCollections/SpecialCollectionAuthors";
import _get from "lodash/get";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Overridable from "react-overridable";
import { Grid, Header } from "semantic-ui-react";

class SpecialCollectionPanelMobile extends Component {
  getCollectionTypeLabel() {
    const { specialCollectionDetails } = this.props;
    const collectionTypeMap = {
      GRADUATE_THESIS: "Graduate Thesis",
      UNDERGRADUATE_THESIS: "Undergraduate Thesis",
      DISSERTATION: "Dissertation",
      ENCYCLOPEDIA: "Enclyclopedia",
      HANDBOOK: "Handbook",
      OTHER: "Other",
    };

    const collectionType = specialCollectionDetails.metadata.collection_type;
    return (
      collectionTypeMap[collectionType] ||
      collectionType ||
      "Special Collection"
    );
  }

  getAcademicInfo() {
    const { specialCollectionDetails } = this.props;
    const academicInfo = _get(
      specialCollectionDetails,
      "metadata.academic_info",
      {}
    );

    const parts = [];
    if (academicInfo.department) parts.push(academicInfo.department);
    if (academicInfo.program) parts.push(academicInfo.program);
    if (specialCollectionDetails.metadata.publication_year) {
      parts.push(specialCollectionDetails.metadata.publication_year);
    }

    return parts.length > 0 ? parts.join(" | ") : null;
  }

  render() {
    const { isLoading, specialCollectionDetails } = this.props;
    const academicInfo = this.getAcademicInfo();

    return (
      <div
        data-test={
          specialCollectionDetails.metadata
            ? specialCollectionDetails.metadata.pid
            : 0
        }
      >
        <Grid className="literature-panel">
          <Grid.Row>
            <Grid.Column mobile={16} textAlign="center">
              <LiteratureCover
                size="medium"
                url={_get(
                  specialCollectionDetails,
                  "metadata.cover_metadata.urls.medium"
                )}
                isLoading={isLoading}
              />
              <ILSHeaderPlaceholder isLoading={isLoading} center="true">
                <div className="mobile-collection-type">
                  {this.getCollectionTypeLabel()}
                </div>
                <Header as="h2" className="document-title">
                  {specialCollectionDetails.metadata.title}
                </Header>
              </ILSHeaderPlaceholder>
              <ILSParagraphPlaceholder linesNumber={2} isLoading={isLoading}>
                <SpecialCollectionAuthors
                  prefix="by "
                  listItemAs="h4"
                  authors={specialCollectionDetails.metadata.authors}
                />
                {academicInfo && (
                  <div className="academic-info-mobile">
                    <b>{academicInfo}</b>
                  </div>
                )}
              </ILSParagraphPlaceholder>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column mobile={16}>
              <ILSParagraphPlaceholder linesNumber={5} isLoading={isLoading}>
                <Header as="h3" content="Abstract" />
                <ShowMoreContent
                  lines={5}
                  content={specialCollectionDetails.metadata.abstract}
                />
              </ILSParagraphPlaceholder>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

SpecialCollectionPanelMobile.propTypes = {
  specialCollectionDetails: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default Overridable.component(
  "SpecialCollectionPanelMobile",
  SpecialCollectionPanelMobile
);
